import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";

const SuccessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fetchAndUpdateUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const hasRun = React.useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const handleSubscriptionSuccess = async () => {
      console.log("SuccessPage: Handling subscription success...");
      setLoading(true);

      try {
        localStorage.removeItem("pendingSubscription");
        localStorage.removeItem("pendingPaypalSubscriptionId");

        const updatedUser = await fetchAndUpdateUser();

        if (updatedUser && updatedUser.isSubscribed) {
          console.log("SuccessPage: Subscription confirmed. Redirecting to MyProperties.");
          
          // Show single success toast
          toast.success(t("subscription_active_toast"), {
            position: "top-center",
            autoClose: 3000,
          });

          // Redirect directly to MyProperties as userType is always "offer"
          navigate("/MyProperties");
        } else {
          console.warn("SuccessPage: User still not subscribed after update. Webhook might be delayed or failed.");
          
          // Show processing message
          toast.info(t("subscription_processing_toast"), {
            position: "top-center",
            autoClose: 5000,
          });
          
          // Still navigate to prevent user from being stuck
          navigate("/MyProperties");
        }
      } catch (error) {
        console.error(
          "SuccessPage: Error during subscription handling:",
          error
        );
        toast.error(t("subscription_error_contact_support_toast"));
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    handleSubscriptionSuccess();
  }, [navigate, fetchAndUpdateUser, t]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f0f0f0",
        color: "#333",
        fontSize: "clamp(18px, 3vw, 28px)",
        fontWeight: "bold",
        textAlign: "center",
        padding: "clamp(15px, 4vw, 30px)",
      }}
    >
      <p>{t("processing_subscription_status")}</p>
      {loading && <p>...</p>}
    </div>
  );
};

export default SuccessPage;
